import { AppBonusData, AppLandingBonuses } from '@monorepo/env-types'

type BonusResult = {
  value: string | number | undefined
  label: string | number | undefined
  bonusId: number | undefined
}

interface Props {
  name: string
  geo?: string
  nameQuery?: string | null
  onSelect?: ({ query }: { query: string | null }) => BonusResult
  appBonus?: { [landingName: string]: AppLandingBonuses }
}

const INITIAL_BONUS_KEY = 'initial'

const toBonusResult = (data: AppBonusData | undefined) => {
  if (!data?.bonusId && !data?.promocode) return

  return {
    value: data.value || data.promocode,
    label: data.value || data.promocode,
    bonusId: data.bonusId,
  }
}

const selectBonusFromValues = (data: AppBonusData[], query: string | null) => {
  const bonusByQuery =
    data.find((bonus) => bonus.value === Number(query) || bonus.promocode === query) ?? data[0]

  return toBonusResult(bonusByQuery)
}

const EMPTY_BONUS_RESULT = { value: undefined, label: undefined, bonusId: undefined }

export const getBonus = ({ appBonus, name, geo, nameQuery = 'bonus', onSelect }: Props) => {
  if (typeof window === 'undefined') return EMPTY_BONUS_RESULT
  const queryValue = nameQuery ? new URLSearchParams(window.location.search).get(nameQuery) : null
  const landingBonusConfig = appBonus?.[name]

  const landingGeoBonusData = geo ? landingBonusConfig?.[geo] : undefined
  const landingGeoBonus = toBonusResult(landingGeoBonusData)
  if (landingGeoBonus) return landingGeoBonus

  const landingBonusValues = landingBonusConfig?.values
  if (landingBonusValues) return selectBonusFromValues(landingBonusValues, queryValue)

  if (onSelect && queryValue) return onSelect({ query: queryValue })

  const landingDefaultBonus = toBonusResult(landingBonusConfig?.default)
  if (landingDefaultBonus) return landingDefaultBonus

  const initialGeoBonusData = geo ? appBonus?.[INITIAL_BONUS_KEY]?.[geo] : undefined
  const initialGeoBonus = toBonusResult(initialGeoBonusData)
  if (initialGeoBonus) return initialGeoBonus

  const initialBonusValues = appBonus?.[INITIAL_BONUS_KEY]?.values
  if (initialBonusValues) return selectBonusFromValues(initialBonusValues, queryValue)

  const initialDefaultBonusData = appBonus?.[INITIAL_BONUS_KEY]?.default
  return toBonusResult(initialDefaultBonusData) ?? EMPTY_BONUS_RESULT
}
